import React, { useEffect, useRef } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { PATH } from '../../constants/router'
import LoadingPopup from '../../components/LoadingPopup'
import appUserService from '../../services/appUserService'
import { PAYMENT_SUCCESS } from '../../constants/payment'

export default function AutoTrafficFineNotificationPaymentSuccess() {
  const history = useHistory()
  const location = useLocation()
  const isRedirectingRef = useRef(false)

  const handleRedirect = (orderId) => {
    if (isRedirectingRef.current) return
    isRedirectingRef.current = true

    if (orderId) {
      history.replace(PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_SUCCESS.replace(':id', orderId))
    } else {
      history.replace(PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_LOOKUP)
    }
  }

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search)
    const rawOrderIdSuccess = urlParams.get('orderIdSuccess') || urlParams.get('orderId')
    const orderId = Number(rawOrderIdSuccess)

    if (!rawOrderIdSuccess || isNaN(orderId)) {
      const timeout = setTimeout(() => {
        handleRedirect(null)
      }, 3000)
      return () => clearTimeout(timeout)
    }

    const startTime = Date.now()
    let pollingInterval = null
    let maxTimeout = null

    const checkPaymentStatus = async () => {
      try {
        const result = await appUserService.getOrderDetail({ id: orderId })
        if (result?.statusCode === 200 && result?.data?.paymentStatus === PAYMENT_SUCCESS) {
          clearInterval(pollingInterval)
          clearTimeout(maxTimeout)
          
          const elapsedTime = Date.now() - startTime
          if (elapsedTime < 4000) {
            setTimeout(() => handleRedirect(orderId), 4000 - elapsedTime)
          } else {
            handleRedirect(orderId)
          }
        }
      } catch (error) {
        console.error(error)
      }
    }

    checkPaymentStatus()
    pollingInterval = setInterval(checkPaymentStatus, 1000)

    maxTimeout = setTimeout(() => {
      clearInterval(pollingInterval)
      handleRedirect(orderId)
    }, 12000)

    return () => {
      clearInterval(pollingInterval)
      clearTimeout(maxTimeout)
    }
  }, [history, location.search])

  return <LoadingPopup type="full" noText />
}
